import React, { FC } from 'react';
import { Lawyer } from '../../enterprise/enterprise.types';
import { PopoverFactoryRenderer } from '../../components/popovers/PopoverFactoryRenderer';
import { LawyerPopover } from '../../lawyer/popover/LawyerPopover';
import { EntityListSubtitle } from './components/subtitle/EntityListSubtitle';
import {
  EntityListItem,
  EntityListIcon,
  EntityListGroup,
} from './components/EntityListComponents';
import { EntityListLinkTitle } from './components/title/EntitlyListLinkTitle';

type Props = {
  lawyers: Array<Lawyer>;
  source: string;
  wording: string;
  handleClickDecision: Function;
  fromModal?: boolean;
};

export const LawyerListWithDecisions: FC<Props> = ({
  source,
  lawyers,
  handleClickDecision,
  wording,
  fromModal = false,
}) => {
  const displayPopover = (element: HTMLElement) => {
    const lawyerId = element.getAttribute('data-lawyer');
    if (lawyerId) {
      return <LawyerPopover source={`${source}_popover`} lawyerId={lawyerId} />;
    }
  };

  return (
    <PopoverFactoryRenderer
      renderTemplate={displayPopover}
      isPopoverInsideModal={fromModal}
    >
      {lawyers.map(lawyer => (
        <EntityListItem key={lawyer.url}>
          <EntityListIcon
            src={`/img/icons/entities/${
              lawyer.isVerified ? 'lawyer-verified' : 'lawyer'
            }.svg`}
            alt="lawyer-icon"
          />
          <EntityListGroup>
            <EntityListLinkTitle
              source={source}
              entityId={lawyer.lawyerId}
              entityUrl={lawyer.url}
              entityName={lawyer.nom}
            />
            <br />
            <EntityListSubtitle
              wording={wording}
              handleClickDecision={handleClickDecision}
              entity={lawyer}
            />
          </EntityListGroup>
        </EntityListItem>
      ))}
    </PopoverFactoryRenderer>
  );
};
